/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 툴바 내부의 특수 아이템 클래스를 정의한다.
 *
 * @file /src/components/toolbar/item/Item.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 6. 12.
 */
import * as parent from '@base/Component';
import { Language, LanguageText } from '@utils/Language';

export interface Listeners<T> extends parent.Listeners<T> {}

export interface Properties<T> extends parent.Properties<T> {
    /**
     * 문자열
     */
    text?: LanguageText;
}

export class Item extends parent.Component {
    /**
     * 컴포넌트 타입
     */
    type = 'toolitem';

    /**
     * 컴포넌트 확장타입
     */
    variant = 'text';

    /**
     * 문자열
     */
    text: LanguageText = null;

    /**
     * 툴바 내부의 특수 아이템 컴포넌트를 정의한다.
     *
     * @param properties - 컴포넌트 초기설정
     */
    constructor(public properties: Pick<Properties<Item>, 'id' | 'text' | 'hidden'> = null) {
        super(properties);

        this.text = this.properties?.text ?? null;
    }

    /**
     * 문자열을 정의한다.
     *
     * @param text - 변경할 문자열
     */
    async setText(text: LanguageText): Promise<void> {
        this.$getComponent().html(await Language.resolveText(text));
    }

    /**
     * 툴바 아이템은 컴포넌트 DOM 렌더링이 필요없으므로, 재정의한다.
     */
    async renderDom(): Promise<void> {}

    /**
     * 컴포넌트 컨테이너를 렌더링한다.
     */
    async renderContainer(): Promise<void> {
        if (this.text !== null) {
            await this.setText(this.text);
        }
    }
}
